<!-- Main modal -->
<div [id]="modalId" tabindex="-1" aria-hidden="true" class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
  <div class="relative p-4 w-full max-w-md max-h-full">
    <!-- Modal content -->
    <div class="relative txt bg-white rounded-lg shadow dark:bg-gray-700">
      <!-- Modal header -->
      <div class="flex items-center justify-between  md:p-5 rounded-t dark:border-gray-600">
        <h3 class="text-xl font-semibold text-gray-900 dark:text-black-900">
        {{ title }}
        </h3>
        <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" [attr.data-modal-hide]="modalId">
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
      </div>
      <!-- Modal body -->
      <form class="p-4 md:p-5" [formGroup]="modalForm" (ngSubmit)="onSubmit()">
        <div class="grid gap-4 mb-4 grid-cols-1"> 
          <div *ngFor="let field of fields">
            <label [for]="field.controlName" class="block mb-2 text-sm font-medium text-gray-900 dark:text-black-900">{{ field.label }}</label>
            <ng-container [ngSwitch]="field.type">
              <!-- Select Input -->
              <select *ngSwitchCase="'select'"
                [name]="field.controlName"
                [id]="field.controlName"
                [formControlName]="field.controlName"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:border-gray-500 dark:placeholder-gray-400 dark:text-black dark:focus:ring-primary-500 dark:focus:border-primary-600"
                [required]="field.required ?? false">
                <option [ngValue]="null" disabled selected>{{ field.placeholder || 'Select an option' }}</option>
                <option *ngFor="let option of field.options" [value]="option.id">{{ option.label }}</option>
              </select>

              <!-- Default Input (for text, number, email, etc.) -->
              <input *ngSwitchDefault
                [type]="field.type"
                [name]="field.controlName"
                [id]="field.controlName"
                [formControlName]="field.controlName"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:border-gray-500 dark:placeholder-gray-400 dark:text-black dark:focus:ring-primary-500 dark:focus:border-primary-600"
                [placeholder]="field.placeholder || ''"
                [required]="field.required ?? false">
            </ng-container>

               <!-- Basic validation message (optional) -->
               <div *ngIf="modalForm.controls[field.controlName]?.invalid && (modalForm.controls[field.controlName]?.dirty || modalForm.controls[field.controlName]?.touched)" class="text-red-600 text-xs mt-1">
                 <div *ngIf="modalForm.controls[field.controlName]?.errors?.['required']">
                   {{ field.label }} est requis.
                 </div>
                 <div *ngIf="modalForm.controls[field.controlName]?.errors?.['email']">
                   S'il vous plaît, entrez une adresse email valide.
                 </div>
                 <!-- Add more specific error messages as needed -->
               </div>
          </div>
        </div>
        <div class="mt-5 flex items-center justify-center">
          <button 
            type="submit" 
            class="text-white inline-flex items-center btn focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-3 text-center" 
            [disabled]="!modalForm.valid" 
            [attr.data-modal-hide]="modalForm.valid ? modalId : null"> 
            Valider
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
